import * as React from 'react';
import { getFrameMeasurements, FrameMeasurementsView } from '@grandvisionhq/fun-products';
import { getAttrValue } from '@grandvisionhq/utils';
import { getActiveVariant } from '../helpers.js';
import { useProductDetailContext } from '../ProductDetail/Context/ProductDetailContext.js';

const ProductFrameMeasurements = ({ product  })=>{
    const { activeSku  } = useProductDetailContext();
    const variant = getActiveVariant(product, activeSku);
    const bridgeWidth = Number(getAttrValue(variant, 'bridgeWidth'));
    const frameWidth = Number(getAttrValue(variant, 'frameWidth'));
    const lensHeight = Number(getAttrValue(variant, 'lensHeight'));
    const lensWidth = Number(getAttrValue(variant, 'lensWidth'));
    const templeLength = Number(getAttrValue(variant, 'templeLength'));
    const frameMeasurements = getFrameMeasurements(bridgeWidth, frameWidth, lensHeight, lensWidth, templeLength);
    if (!frameMeasurements) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(FrameMeasurementsView, {
        measurements: frameMeasurements
    });
};

export { ProductFrameMeasurements };
//# sourceMappingURL=ProductFrameMeasurements.js.map
